module.exports = __webpack_public_path__ + "static/img/bannerword.0008e67.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/bannerword.png
// module id = hiP6
// module chunks = 45